import styled from 'styled-components';
import { hexToRgba } from '../../utils/style';
import { BaseStyledComponentProps, StyleColor } from '../../utils/styles-constants';

const HeaderBlockContainer = styled('div')`
	display: flex;
	align-items: center;
	background-color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 3)};
	height: 50px;
	justify-content: space-between;
	padding-left: 15px;
	border: none;

	@media print {
		background-color: ${StyleColor.Grey50};
	}
`;

const HeaderBlockTitle = styled('div')`
	color: ${(props: BaseStyledComponentProps) => hexToRgba(props.theme.primary.strongColor, 50)};
	font-size: 15px;
	letter-spacing: 0.2px;
	white-space: nowrap;
	overflow: hidden;
	display: flex;
	flex-flow: row nowrap;
	width: 100%;

	@media print {
		color: #000;
	}
`;

const Title = styled('div')`
	font-weight: 600;
	font-size: 16px;
`;

const Subtitle = styled('div')`
	padding: 0 3px;
`;

const Option = styled('div')`
	flex-grow: 1;
	text-align: right;
	padding: 0 10px;
`;

export { HeaderBlockContainer, HeaderBlockTitle, Title, Option, Subtitle };


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/HeaderBlock/styles.ts